export interface CsmUserStatusResponse {
  contactExists?: boolean;
  isPortalUser?: boolean;
  hasCustomerAllCases?: boolean;
  email?: string;
  userName?: string;
  externalId?: string;
  [key: string]: any;
}

export enum CsmProvisioningAction {
  LoginAdd = 0,
  LoginRemove = 1,
  CustomerAllCasesAdd = 2,
  CustomerAllCasesRemove = 3
}

export interface CsmUserProvisioningRequest {
  actions: CsmProvisioningAction[];
  externalId?: string;
  customerNumber?: string;
  email?: string;
  requestedByName?: string;
  requestedByEmail?: string;
  requestedByGuid?: string;
}

export interface CsmUserProvisioningResponse {
  success?: boolean;
  status?: string;
  detail?: string;
  problems?: string[];
  effectiveEmail?: string;
}
